import React, { FC, useCallback } from "react"

interface Props {
  label: string
  value: number
  onChange: (val: number) => void
  disabled?: boolean
}

export const WeightSlider: FC<Props> = ({ label, value, onChange, disabled }) => {
  const handleInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const num = parseInt(e.target.value, 10)
      if (!isNaN(num) && num >= 0 && num <= 100) onChange(num)
    },
    [onChange]
  )

  return (
    <div className="flex items-center gap-4">
      <span className="w-40 text-sm font-medium text-gray-700 dark:text-gray-300">{label}</span>
      <input
        type="range"
        min={0}
        max={100}
        value={value}
        onChange={handleInput}
        className="range range-primary range-sm flex-1"
        disabled={disabled}
      />
      <input
        type="number"
        min={0}
        max={100}
        value={value}
        onChange={handleInput}
        className="input input-bordered input-sm w-20 text-center dark:bg-[#1a1b2e] dark:border-[rgba(255,255,255,0.1)]"
        disabled={disabled}
      />
      <span className="text-sm text-base-content/60 w-4">%</span>
    </div>
  )
}
